module.exports = __webpack_public_path__ + "static/media/iphone_11_red.d2be33fc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/custom-products/iphone/iphone_11_red.png
// module id = 2071
// module chunks = 0